"use strict";

var checkClientSession = function checkClientSession(client) {
  return client.checkSessionAsync({}).then(function () {
    return true;
  }).catch(function (err) {
    console.info('Client Failed: ', err);
    return false;
  });
};
var makeGetClient = function makeGetClient(_ref) {
  var primaryDomainClient = _ref.primaryDomainClient,
    secondaryDomainClient = _ref.secondaryDomainClient;
  var auth0Client = null;
  return function () {
    if (auth0Client) {
      console.info('Client: using cache');
      return Promise.resolve(auth0Client);
    }
    return checkClientSession(primaryDomainClient).then(function (primaryAuth0DomainClientSuccessful) {
      if (primaryAuth0DomainClientSuccessful) {
        console.info('Auth0 Domain: Session found');
        auth0Client = primaryDomainClient;
        return auth0Client;
      }
      return checkClientSession(secondaryDomainClient).then(function (secondaryDomainClientSuccessful) {
        if (secondaryDomainClientSuccessful) {
          console.info('Custom Domain: Session found');
          auth0Client = secondaryDomainClient;
          return auth0Client;
        }
        console.info('Auth0 Domain: defaulting');
        auth0Client = primaryDomainClient;
        return auth0Client;
      });
    });
  };
};
module.exports = {
  makeGetClient: makeGetClient
};